import { useAtom } from 'jotai';
import { showMeetingsAtom } from '../../meetings/messages';
import { useEffect } from 'react';
import { BuildInAppToolId } from '../types/appTools';

// TODO: think how to external this fix to be outside the app tools
const useShowMeeting = (selectedApp, setSelectedApp, isExpanded, setIsExpanded) => {
    const [showMeetings, setShowMeetings] = useAtom(showMeetingsAtom);

    useEffect(() => {
        setShowMeetings(false);
    }, [selectedApp]);

    useEffect(() => {
        setShowMeetings(false);
    }, [isExpanded]);

    useEffect(() => {
        if (showMeetings) {
            setSelectedApp(BuildInAppToolId.Messages);
            setIsExpanded(true);
        }
    }, [showMeetings]);
};

export default useShowMeeting;
